import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const SatisfactionScoreColumn = (params) => {
  const { value } = params?.data?.satisfactionScore ?? {};
  const { satisfactionScore, isReportee } = value ?? {};
  const textColor =
    satisfactionScore !== null && satisfactionScore !== undefined && satisfactionScore > 50 ? '#44812F' : '#B96400';

  return (
    <Flex w="100%" h="100%" alignItems="center">
      {isReportee ? (
        <TextBodyMedium>NA</TextBodyMedium>
      ) : (
        <TextBodyMedium color={textColor}>
          {![null, undefined].includes(satisfactionScore) ? `${satisfactionScore}%` : '-'}
        </TextBodyMedium>
      )}
    </Flex>
  );
};
export default SatisfactionScoreColumn;
